export default {
  items: [],
  defaultSort: {
    page: 1,
    column: 'venue_name',
    order: 'ascending',
    limit: 25,
  },
  sort: {
    page: 1,
    column: 'venue_name',
    order: 'ascending',
    limit: 25,
    filter: '',
  },
  more: true,
  loading: false,
  total: 0,
  overallCount: 0,
};
